// hooks/useCurrency.js
import { useState, useEffect, useCallback } from "react";
import { useAuth } from "../features/auth/AuthProvider"; // Still needs auth context for the Firebase user and token
import axios from "axios";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export const useCurrency = () => {
  const { user, authLoading, logout } = useAuth(); // Get firebaseUser from AuthContext
  const [essence, setEssence] = useState(null);
  const [stamina, setStamina] = useState(null);
  const [supporterPlan, setSupporterPlan] = useState(null);
  const [currencyLoading, setCurrencyLoading] = useState(true);

  const fetchCurrencyData = useCallback(async () => {
    if (user?.firebaseUser) {
      setCurrencyLoading(true);
      try {
        const idToken = await user.firebaseUser.getIdToken(true);
        const response = await axios.get(`${baseUrl}/users`, {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        });
        setEssence(response.data.user.essence || 0);
        setStamina(response.data.user.stamina || 0);
        setSupporterPlan(response.data.user.supporterPlan || null);
      } catch (error) {
        console.error("Error fetching currency data:", error);
        setEssence(" "); // Indicate error
        setStamina(" "); // Indicate error
        setSupporterPlan(null);
        if (error.response && error.response.status === 401) {
          console.warn(
            "User token expired or invalid during currency fetch. Logging out."
          );
          logout(); // Use the logout from AuthProvider
        }
      } finally {
        setCurrencyLoading(false);
      }
    } else {
      setEssence(null);
      setStamina(null);
      setSupporterPlan(null);
      setCurrencyLoading(false);
    }
  }, [user, logout]); // Depend on 'user' and 'logout'

  useEffect(() => {
    // Only fetch currency once auth state is resolved and user is available
    if (!authLoading) {
      fetchCurrencyData();
    }
  }, [user, authLoading, fetchCurrencyData]); // Re-fetch when user or authLoading changes

  return {
    essence,
    stamina,
    supporterPlan,
    currencyLoading,
    refreshCurrency: fetchCurrencyData, // Expose a specific refresh function
  };
};
